<template>
	<!-- 支付页面 -->
	<div class="main">
		<div class="title">{{info.productName}}</div>
		<Steps :current="2" style="margin:20px auto; width:700px;padding-left:116px">
			<Step title="申请信息"></Step>
			<Step title="确认信息"></Step>
			<Step title="支付"></Step>
		</Steps>
		<div class="order">
			<div class="order-title">订单信息</div>
			<Table :columns="columns" border :data="orderData">
				<template slot-scope="{ row }" slot="productName">
					<b style="font-size:16px;">{{row.productName}}</b>
				</template>
				<template slot-scope="{ row }" slot="payPrice">
					<div class="price">
						<p>
							<span class="price-label">订单金额：</span>
							<span class="price-value">{{row.totalAmount}}元</span>
						</p>
					</div>
				</template>
			</Table>
		</div>
		<div class="pb50">
			<div class="center" v-if="info.orderStatus=='UNPAID'">
				<template>当天24时前未完成支付的订单，将自动关闭。</template>
			</div>
			<div v-if="info.orderStatus&&info.orderStatus!='UNPAID'">支付状态：{{info.orderStatusDesc}}</div>
			<div class="mt15" v-if="info.orderStatus=='UNPAID'&&info.totalAmount>0" >
				<p class="form">
					<span class="form-label" style="line-height: normal;">支付方式：</span>
					<span class="form-value">
						<RadioGroup v-model="payType" @on-change="payTypeChange" >
							<Radio :label="item.key" :disabled="Boolean(info.payVoucherUrl)" v-for="(item, index) in payTypeList" :key="index">{{item.value}}</Radio>
						</RadioGroup>
					</span>
				</p>
				<div v-if="payType=='PUBLIC_BANK'||payType=='THIRD_PARTY_PUBLIC_BANK'" class="mt10">
					<div class="form">
						<div class="form-label">&nbsp;</div>
						<div class="form-value">
							<p>如选择对公支付，请及时付款至以下指定账户，平台会根据您已提交的信息生成各类投保订单。</p>
							<div class="mt10" style="background: #f2f2f2;padding-right: 40px;" v-if="payType=='THIRD_PARTY_PUBLIC_BANK'">
								<!-- 阳光对公支付信息 人资 meng-->
								<template v-if="info.productCode=='SUNLIGHT_EMPLOYER_LIABILITY'">
									<p>
										<span class="form-label">名称：</span>
										<span class="form-value">阳光财产保险股份有限公司青岛分公司</span>
									</p>
									<p>
										<span class="form-label">开户行：</span>
										<span class="form-value">中国工商银行青岛市东海中路支行</span>
									</p>
									<p>
										<span class="form-label">账号：</span>
										<span class="form-value">380 302 792 920 012 7875</span>
									</p>
								</template>
								<!-- 大地对公支付信息 人资 meng-->
								<template v-else>
									<p>
										<span class="form-label">名称：</span>
										<span class="form-value">中国大地财产保险股份有限公司青岛分公司</span>
									</p>
									<p>
										<span class="form-label">开户行：</span>
										<span class="form-value">中国工商银行青岛市南第二支行</span>
									</p>
									<p>
										<span class="form-label">账号：</span>
										<span class="form-value">3803 0349 1910 0012 157</span>
									</p>
								</template>
							</div>
							<div class="mt10">
								<p class="red" style="display: flex; align-items: center;">
									<span class="form-label">注意：</span>
									<span class="form-value">1、如选择对公支付，在付款后，请及时上传支付凭证；</span>
								</p>
								<p class="red" style="display: flex;">
									<span class="form-label"></span>
									<span class="form-value">2、确认收到款项后，会向手机号<u>{{info.applicantList[0].contactPhone||''}}</u>发送短信；</span>
								</p>
								<p class="red" style="display: flex;">
									<span class="form-label"></span>
									<span class="form-value">3、对公付款时请备注以下信息，以避免影响承保；</span>
								</p>
								<p class="mt15">
									<span class="form-label"></span>
									<span class="form-value">
										{{info.applicantName}}+{{info.productName}}
										<Button
										type="primary"
										size="small"
										@click="copy"
										class="copyBtn"
										:data-clipboard-text="`${info.applicantName}+${info.productName}`"
										>复制</Button>
									</span>
								</p>
							</div>
						</div>
					</div>
					<div style="text-align: center;">
						<p class="mt15">
							<span class="form-label"></span>
							<UploadFile @on-success="handleSuccess" type="select">
								<Button type="primary">上传支付凭证</Button>
							</UploadFile> 
							<a @click="openOriginFile(info.payVoucherUrl)" v-if="info.payVoucherUrl">查看文件</a>
						</p>
						<p class="mt15">
							<span class="form-label"></span>
							<Button type="success" @click="confirmUpload" :disabled="!Boolean(info.payVoucherUrl)">提交凭证</Button>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
	</template>
	<script>
	import QRCode from "qrcodejs2";
	import Clipboard from "clipboard";
	import UploadFile from '@/components/common/UploadFileImg'
	import track from "@/mixin/track";
	export default {
		components:{UploadFile},
		mixins:[track],
		data() {
			return {
				columns: [
					{
						title: "产品名称",
						key: "productName",
						slot: "productName"
					},
					{
						title: "订单号",
						key: "orderNo"
					},
					{
						title: "订单创建时间",
						key: "createTime",
						width: 200
					},
					{
						title: "支付",
						slot: "payPrice",
						width: 300
					}
				],
				orderData: [],
				info: {},
				clock: undefined,
				flag: true,
				use: true,
				payType: "",
				orderNo:this.$route.query.orderNo,
				qrcode:null,
				loading:false,
				payTypeList:[],
				modalLoading:false,
				form:{
					isApplicantPay:'0'
				},
				ruleValidate: {
                    payerName: [
                        { required: true, message: '付款人名称不能为空', trigger: 'blur' }
                    ],
                    payerIdCard: [
                        { required: true, message: '付款人身份证号码不能为空', trigger: 'blur' },
						{message:'格式错误', trigger:'blur', pattern: this.rules.idcard }
                    ],
					reason: [
                        { required: true, message: '代付原因不能为空', trigger: 'blur' }
                    ],
					relationshipToApplicant: [
                        { required: true, message: '付款人与投保企业关系不能为空', trigger: 'blur' }
                    ]
                },
				payUrl:'',
                payParams: {
                    requestDoc:""
                },
				param:{},
				zhonganpayForm:{},
				isLock:false,
				newPayObj:{},
				payLoading:false
			};
		},
		created() {
			this.getOrderInfo();
		},
		mounted () {
			// 回溯 开始录制
			this.$nextTick(this.startRecord);
		},
		beforeRouteLeave (to, from, next) {
			this.clearCheckStatus();
			this.$nextTick(()=>{
				next();
			})
		},
		methods: {
			async getPayInfo(){
				await this.$axios.post('/broker/dict/item/list.json',{
					bizId:"SERVICE_PLATFORM",
                    companyId:"10095",
                    dictCode:"agent_code",
					productCode: this.info.productCode,
					key: this.info.applicantList[0].subjectCode
				}).then(res=>{
					this.newPayObj = res&&res.length>0?res[0]:{};
				});
			},
			// 获取付款方式
			async getPayType(){
				await this.$axios.post('/broker/product/paymentSourceOptionalList',{
					productCode:this.info.productCode
				}).then(res=>{
					this.payTypeList=res;
				});
			},
			// 获取订单信息
			getOrderInfo() {
				this.$axios.post('/broker/order/detail',{
					orderNo:this.orderNo
				}).then(res=>{
					this.info = res;
					this.info.applicantName=(res.applicantList&&res.applicantList.length>0?res.applicantList[0]:{}).subjectName
					this.orderData=[res];
					this.getPayType();
					if(this.info.orderStatus=='UNPAID'){
						// 待支付
						if(res.insuranceApplicationId){
							this.getPolicyInfo(res.insuranceApplicationId,'application')
						}else{
							this.getPolicyInfo(res.insurancePolicyId,'policy')
						}
					}
					this.payType = 'THIRD_PARTY_PUBLIC_BANK';
				});
			},
			// 获取投保单信息
			getPolicyInfo(id,type){
				let url=type=='application'?'/broker/insurance/application/detail':'/broker/insurance/policy/detail'
				this.$axios.post(url,{
					applicationId:id,
					insurancePolicyId:id
				}).then(res=>{
					this.info.phone=res.applicantList&&res.applicantList.length>0?res.applicantList[0].contactPhone:''
				});
			},
			// 获取二维码url
			getQrCodeUrl(){
				return this.$axios.post('/broker/order/payUrl',{
					orderNo:this.orderNo,
					paymentSource:this.payType
				})
			},
			// 获取二维码
			async getQrCode() {
				let payItem=this.payTypeList.find(item=>{
					return item.key==this.payType
				})
				if(payItem&&!payItem.payUrl){
					payItem.payUrl=await this.getQrCodeUrl()
				}
				if(!this.qrcode){
					this.qrcode = new QRCode("qrcode", {
						width: 200,
						height: 200, // 高度
						text: payItem.payUrl // 二维码内容
					});
				}else{
					this.qrcode.makeCode(payItem.payUrl)
				}
				this.checkStatus();
			},
			/*检查支付状态*/
			checkStatus() {
				this.clock = setInterval(() => {
					if (this.flag) {
						this.flag = false;
						this.$axios.post('/broker/order/detail',{
							orderNo:this.orderNo
						}).then(res=>{
							if(res.orderStatus=='PAID'){
								clearInterval(this.clock);
								this.$router.push({
									path:`/my/orderDetail/${this.orderNo}`
								});
							}
							this.flag = true;
						}).catch(res=>{
							this.flag = true;
						})
					}
				}, 3000);
			},
			// 清除循环
			clearCheckStatus() {
				clearInterval(this.clock);
			},
			// 切换支付方式
			payTypeChange() {
				this.clearCheckStatus();
				if (this.payType !== "PUBLIC_BANK"&&this.payType !== "THIRD_PARTY"&&this.payType!=='THIRD_PARTY_PUBLIC_BANK'&&this.payType!=='THIRD_PARTY_ONLINE') {
					this.getQrCode();
				}
			},
			// 复制
			copy() {
				let clipboard = new Clipboard(".copyBtn");
				clipboard.on("success", e => {
					this.toast("复制成功"); // 释放内存
					clipboard.destroy();
				});
				clipboard.on("error", e => {
					// 不支持复制
					this.alert("该浏览器不支持自动复制"); // 释放内存
					clipboard.destroy();
				});
			},
			// 上传成功payType
			handleSuccess(val){
				this.$set(this.info,'payVoucherUrl',val.url)
			},
			confirmUpload(){
				this.confirm('确定提交已上传凭证？',()=>{
					this.$axios.post('/broker/order/upload/payVoucher.all',{
						orderNo:this.orderNo,
						payVoucherUrl:this.info.payVoucherUrl,
						paymentSource:this.payType
					}).then(async res=>{
						if(res.code==10000000){
							// 回溯 停止录制
							await this.stopRecord({
								policy_id: this.info.endorseNo?this.info.endorseNo:this.info.applicationNo
							});
							this.$router.push({
								path:`/pay-success/${this.orderNo}`
							});
							window.location.href=`/common.html#/paySuccessCCIC/${this.orderNo}?phone=${res}`
						}
					});
				})
			}
		}
	};
	</script>
	<style scoped lang="less">
	.main {
		padding: 20px 30px;
		margin-top:95px;
		min-height:calc(100vh - 420px)
	}
	.pb50{
		padding-bottom: 50px;
	}
	.order-title {
		// font-size: 14px;
		margin-bottom: 10px;
	}
	.center {
		font-size: 25px;
		font-weight: bold;
		margin-top: 15px;
		color: #ff6600;
	}
	.pay {
		margin-top: 10px;
		display: flex;
		justify-content: center;
		text-align: center;
		width: 200px;
		margin-left: 45px;
	}
	.fz16{
		font-size: 1.142857em;
	}
	.code > p {
		margin-top: 15px;
	}
	.price {
		font-size: 1.142857em;
		&-label {
			width: 7em;
			display: inline-block;
			line-height: 2;
			text-align: right;
			font-size: 1.142857em;
			&.small{
				width: 92px;
			}
		}
		&-value {
			color: red;
			font-size: 1.142857em;
			&.disabled{
				color: #999;
				text-decoration: line-through;
			}
		}
	}
	.form {
		margin-top: 10px;
		display: flex;
		align-items: center;
		// font-size: 14px;
		&-label {
			width: 7em;
			display: inline-block;
			line-height: 2;
			text-align: right;
		}
		.red {
			color: red;
		}
	}
	.publicPay {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		.note {
			// font-size: 12px;
		}
	}
	.cModel{
		width:100%;
		color: rgba(16, 16, 16, 1);
		// font-size: 14px;
		text-align: center;
	}
	</style>


// WEBPACK FOOTER //
// src/pages/common/components/pay/indexDadi.vue